import apiFetch from '../apiFetch'

export default function (token, documentTypeMetadata) {
  return apiFetch({ endPoint: `Metadata/${documentTypeMetadata.metadatoId}`, method: 'PUT', body: documentTypeMetadata, token: token })
}
